import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// ngrx
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/catch';
import { takeWhile, map, catchError } from 'rxjs/operators';

// services
import { ErrorHandler } from './error-handler.service';
// models
import { AdminDateTime } from '../models/admin-datetime.interface';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, AMEND_DELIVERY_DATETIME, AMEND_COLLECTION_DATETIME } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class AdminDatetimeAmendService {

  private _token;

  public datetimeUpdated$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;  }

  amendDeliveryDateTime(request: AdminDateTime, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    this._http.post(API_PATH + AMEND_DELIVERY_DATETIME, request, {headers: headers})
      .subscribe(
        res => {
          this.datetimeUpdated$.next(true);
        },
        err => {
          this.datetimeUpdated$.next(false);
          this._errorService.handleError(err);
          return;
        });

  }

  amendCollectionDateTime(request: AdminDateTime, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    this._http.post(API_PATH + AMEND_COLLECTION_DATETIME, request, {headers: headers})
      .subscribe(
        res => {
          this.datetimeUpdated$.next(true);
        },
        err => {
          this.datetimeUpdated$.next(false);
          this._errorService.handleError(err);
          return;
        });

  }

}
